import { render } from "./ModalesRoles.vue?vue&type=template&id=206ce3d6"
import script from "./ModalesRoles.vue?vue&type=script&lang=js"
export * from "./ModalesRoles.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__